// Copyright (c) MobiFactory. All rights reserved.
// This source code is the property of MobiFactory. It is exclusively available to customers who have a valid user license.
// See LICENSE.txt file in the project root for full license information.

import backend from "../backend";
const BASE_URI = "/contactdetails/";

export default {
  /**
   * Gets the ContactSummary from the backend server
   * @param {string} contactId - id of the contact to retrieve
   * @returns {object} ContactSummary
   */
  getContactSummary(contactId: string) {
    return backend.get(BASE_URI + contactId + "/summary");
  },
};
